import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Same values as frontend/src/theme.ts in the original app.
export const colors = {
  bg: "#0A0A0A", surface: "#121212", card: "#1A1A1A", cardElevated: "#242424", border: "#333333",
  text: "#FFFFFF", textSecondary: "#A0A0A0", accent: "#4CCC06", accentHover: "#3DA505",
  success: "#4CCC06", warning: "#FFB800", error: "#FF3333",
};
const OVERRIDES = {
  rental_customer: { accent: "#FFD400", accentHover: "#CCAA00", success: "#FFD400" },
  machine_owner: { accent: "#FFFFFF", accentHover: "#E5E5E5", success: "#FFFFFF" },
  prospect: { accent: "#FFB347", accentHover: "#E59A2B", success: "#FFB347" },
};
export const themeForRole = (role) => ({ ...colors, ...(OVERRIDES[role] || {}) });
export const useTheme = () => themeForRole(useAuth()?.user?.role);

export const DESKTOP_BREAKPOINT = 900;
export const useWindowWidth = () => {
  const [w, setW] = useState(() => window.innerWidth);
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return w;
};
